export default "__VITE_ASSET__40d70445__"